// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");

function bottomUpProverParamsMakeDefault(asrtLabel, maxSearchDepthOpt, lengthRestrictOpt, allowNewDisjForExistingVarsOpt, allowNewStmtsOpt, allowNewVarsOpt, deriveFromOnLevel0Opt, deriveFromOnLevel1Opt, maxNumberOfBranches) {
  var maxSearchDepth = maxSearchDepthOpt !== undefined ? maxSearchDepthOpt : 4;
  var lengthRestrict = lengthRestrictOpt !== undefined ? lengthRestrictOpt : "Less";
  var allowNewDisjForExistingVars = allowNewDisjForExistingVarsOpt !== undefined ? allowNewDisjForExistingVarsOpt : true;
  var allowNewStmts = allowNewStmtsOpt !== undefined ? allowNewStmtsOpt : true;
  var allowNewVars = allowNewVarsOpt !== undefined ? allowNewVarsOpt : false;
  var deriveFromOnLevel0 = deriveFromOnLevel0Opt !== undefined ? deriveFromOnLevel0Opt : [];
  var deriveFromOnLevel1 = deriveFromOnLevel1Opt !== undefined ? deriveFromOnLevel1Opt : [];
  return {
          customParams: undefined,
          maxSearchDepth: maxSearchDepth,
          assertionParams: [
            {
              minDist: 0,
              maxDist: 0,
              assertionsToUse: Belt_Option.map(asrtLabel, (function (label) {
                      return [label];
                    })),
              matches: undefined,
              deriveFrom: deriveFromOnLevel0,
              allowNewDisjointsForExistingVariables: allowNewDisjForExistingVars,
              allowNewStatements: allowNewStmts,
              allowNewVariables: allowNewVars,
              statementLengthRestriction: "No",
              maxNumberOfBranches: maxNumberOfBranches
            },
            {
              minDist: 1,
              maxDist: undefined,
              assertionsToUse: undefined,
              matches: undefined,
              deriveFrom: deriveFromOnLevel1,
              allowNewDisjointsForExistingVariables: allowNewDisjForExistingVars,
              allowNewStatements: allowNewStmts,
              allowNewVariables: false,
              statementLengthRestriction: lengthRestrict,
              maxNumberOfBranches: maxNumberOfBranches
            }
          ],
          updateParamsStr: undefined,
          updateParams: undefined
        };
}

function lengthRestrictToStr(len) {
  switch (len) {
    case "No" :
        return "No";
    case "LessEq" :
        return "LessEq";
    case "Less" :
        return "Less";
    
  }
}

function lengthRestrictFromStr(str) {
  switch (str) {
    case "Less" :
        return "Less";
    case "LessEq" :
        return "LessEq";
    case "No" :
        return "No";
    default:
      return ;
  }
}

function lengthRestrictFromStrExn(str) {
  var v = lengthRestrictFromStr(str);
  if (v !== undefined) {
    return v;
  }
  throw {
        RE_EXN_ID: Common.MmException,
        _1: {
          msg: "Cannot convert '" + str + "' to lengthRestrict."
        },
        Error: new Error()
      };
}

function jsonToCustomParams(prim) {
  return prim;
}

exports.jsonToCustomParams = jsonToCustomParams;
exports.bottomUpProverParamsMakeDefault = bottomUpProverParamsMakeDefault;
exports.lengthRestrictToStr = lengthRestrictToStr;
exports.lengthRestrictFromStr = lengthRestrictFromStr;
exports.lengthRestrictFromStrExn = lengthRestrictFromStrExn;
/* Common Not a pure module */
